import { QUERY_STRING_STORAGE_KEY } from '@bizzabo/website-sections';

export const saveUrlParamsToSessionStorage = ({ windowLocationSearch, eventId }) => {
    if (windowLocationSearch && eventId) {
        try {
            window.sessionStorage.setItem(`${QUERY_STRING_STORAGE_KEY}-${eventId}`, windowLocationSearch);
        } catch (e) {
            console.warn('Could not access session storage due to privacy settings');
        }
    }
};
